import { BaseStore } from "./base_store";
import { runInAction, makeAutoObservable } from "mobx"
// import UserAPI from "../api/user";
import ProjectAPI from "api/project";
import { api_get } from "api/utils"

export type ProjectProps = {
    uuid: string;
	key: string;

	title: string;
	identity: string;
	cadence: string;

	// mutuals_project: boolean;
	visibility?: number;
	date_created?: string;
	date_updated?: string;
	updateProps?: (attributes: ProjectProps) => void;
};

// Domain object Project
export class Project implements ProjectProps {
    uuid = ""
	key = "";

	title = "";
	identity = "";
	cadence = "";

	visibility = 0;
	date_created = "";
	date_updated = "";

	constructor(attributes: ProjectProps) {
		makeAutoObservable(this, {
			updateProps: false
		})
		if(attributes) {
			this.updateProps(attributes);
    	}
	}

	updateProps(attributes: ProjectProps) {
		runInAction(() => {
			Object.assign(this, attributes);
		});
	}

}


export class ProjectStore extends BaseStore<ProjectProps, Project> {

	/*
	getUserProjects(userKey: string) {
		return this.items.slice().filter((c) => c.user === userKey)
	}
	*/

	getProject(key: string) {
		return this.items.find((c) => (c.uuid === key || c.key === key));
	}

	async fetchUserProjects(cursor = "") {
		return ProjectAPI.list(cursor).then((resp) => {
			this.receiveUpdate(resp.items)
			if(resp.cursor) {
				this.fetchUserProjects(resp.cursor);
			}
		})
	}

	async fetchIdentityProjects(identityKey: string, cursor = "") {
		return ProjectAPI.listByIdentity(identityKey, cursor).then((resp) => {
			this.receiveUpdate(resp.items)
			if(resp.cursor) {
				this.fetchIdentityProjects(identityKey, resp.cursor);
			}
		})
	}

	async fetchProject(identity: string, projectKey: string) {
        const resp = await api_get(`/project/${projectKey}`, { identity });
        const a = await resp.json(); // as ProjectProps;
        console.log("fetchProject", a);
        this.receiveUpdate(a);
        return a;
	}

    async fetchDedicatedIdentityProjects(assistantIdentityKey="", identityKey="", cursor="") {
		return ProjectAPI.listByDedicatedIdentity(assistantIdentityKey, identityKey, cursor).then((resp) => {
			this.receiveUpdate(resp.items);
			if(resp.cursor) {
				this.fetchDedicatedIdentityProjects(assistantIdentityKey,
                    identityKey,
                    resp.cursor);
			}
		});
    }

	modelConstructor() {
		return Project;
	}

	async createProject(project: ProjectProps): Promise<ProjectProps> {
		return ProjectAPI.create(project.title.trim(),
            project.cadence,
            project.identity,
            !project?.visibility ? "0" : project.visibility.toString(),
        ).then((json) => {
			this.receiveUpdate(json);
			return json as ProjectProps;
		});

	}



	async createProjectByDedicated(workKey: string, project: ProjectProps): Promise<ProjectProps> {
		return ProjectAPI.createByAssistant(
            workKey,
            project.title.trim(),
            project.cadence,
            project.identity,
        ).then((json) => {
			this.receiveUpdate(json);
			return json as ProjectProps;
		});

	}


	async updateProject(project: Project): Promise<Project> {
	//projectKey: string, title: string, cadence: string, identity: string, icon: string)
		return ProjectAPI.update(project.key,
			project.title.trim(),
			project.cadence,
			project.identity,
			project.visibility.toString()).then((json) => {
			this.receiveUpdate(json);
			return json as Project;
		});
	}


}
